import component from './LayoutFooterless.vue'
export default component
